function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.375 1.5H9V3.75H4.5V1.5H1.125C0.503906 1.5 0 2.00391 0 2.625V10.875C0 11.4961 0.503906 12 1.125 12H12.375C12.9961 12 13.5 11.4961 13.5 10.875V2.625C13.5 2.00391 12.9961 1.5 12.375 1.5ZM6.75 5.25C7.57734 5.25 8.25 5.92266 8.25 6.75C8.25 7.57734 7.57734 8.25 6.75 8.25C5.92266 8.25 5.25 7.57734 5.25 6.75C5.25 5.92266 5.92266 5.25 6.75 5.25ZM8.93672 10.5H4.56328C4.31953 10.5 4.12266 10.2656 4.19766 10.0359C4.39219 9.43594 4.95703 9 5.625 9H5.81719C6.10547 9.11953 6.41953 9.1875 6.75 9.1875C7.08047 9.1875 7.39687 9.11953 7.68281 9H7.875C8.54062 9 9.10547 9.43359 9.30234 10.0359C9.37734 10.2656 9.18047 10.5 8.93672 10.5ZM8.25 0.75C8.25 0.335156 7.91484 0 7.5 0H6C5.58516 0 5.25 0.335156 5.25 0.75V3H8.25V0.75Z"
});

function SvgProfileCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "#3D4B57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCard);
export default __webpack_public_path__ + "static/media/profile-card.7ff3cb46.svg";
export { ForwardRef as ReactComponent };